export default __webpack_public_path__ + "static/media/img1.6f7d0d9c.jpg";